module.exports = __webpack_public_path__ + "img/shopify.0feb7815.png";